export function elementInViewport(el, {x = true, y = true, offset = 0} = {}) {
    const elOffset = {
        top: el.getBoundingClientRect().top,
        left: el.getBoundingClientRect().left,
    };

    const xOk = x ? (elOffset.left < 0 ? false : window.innerWidth - elOffset.left - el.clientWidth + offset > 0) : true;
    const yOk = y ? window.innerHeight - (el.clientHeight - (window.scrollY - elOffset.top)) - window.scrollY + offset > 0 : true;

    return xOk && yOk;
}
